export default "__VITE_ASSET__BB2juoMi__"